import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class SalePointSelectorService {
  private showSelectorSource = new BehaviorSubject<boolean>(false);
  showSelector$ = this.showSelectorSource.asObservable();


  setShowSelector(value: boolean) {
    this.showSelectorSource.next(value);
  }
}
